import React, { Component, Fragment } from "react";
import { connect } from 'react-redux';
import queryString from "query-string";

import { Title, Body, Subtitle, Micro } from '@vds/typography';
import { Modal, ModalTitle, ModalBody } from '@vds/modals';
import { TextLink, Button } from '@vds/buttons';
import { Input } from '@vds/inputs';
import { UnorderedList, ListItem } from '@vds/lists'
import { Grid, Row, Col } from '@vds/grids';
import InnerHTML from 'dangerously-set-html-content'
import { Loader } from '@vds/loaders';
import StreetAddress from '../BulkAddressValidationPage/StreetAddress/StreetAddress'
import Unit from '../BulkAddressValidationPage/Unit/Unit'
// import CheckAvailability from '../AddressValidationPage/CheckAvailability/CheckAvailability'
import ExistingCustomer from '../AddressValidationPage/ExistingCustomer/ExistingCustomer'
import PendingOrder from '../AddressValidationPage/PendingOrder/PendingOrder';
import SpinnerComponent from '../../Common/Spinner/Spinner';




import styled from 'styled-components';
import {
   saveIndex, submitBulkPayloadAddress, setHasMutipleAddress, enableCheckAvailblityButton, resetZipcodeForm, enableCheckAvailblity, disableCheckAvailblity, setBannerInfo, setNewAddressFlow,
    setExistingCustomer, setAddressInfo, redirectLBOPage, hasPendingOrder, showSpinner, resetDoLoopFlags, checkAvailAPI,
    setEmptyUnitsError,fetchUnitBulkStatus, multipleAddrSelectionsWithId, postUIEventLog, setDontShowUnit, getLqPageAds, setCityAndState
} from './../BulkAddressValidationPage/containers/action';

import { getChatInfo } from './containers/action';

import './BulkAddressValidationPage.css'
import { handleSignInClickEvent, isIEBrowser, isNightTimeWindow } from './../../utils/common';
import { EXISTING_USER_URL } from './../../containers/APIurls';
import * as SiteAnalytics from '../../sitecatalyst';
import { toggleGlobalErrorMessage, saveCurrentLocation } from '../../../src/containers/actions';
// C:\gbcom-ui\gbcom-ui\src\containers\actions.js

// src\containers\actions.js

import { ENABLE_OMNI_CART, ENABLE_AEM_CHANGES, STATE_SELECT,GOOGLE_RECAPTCHA_SITEKEY } from '../../../src/containers/constants';
import map from 'lodash/map';
import isEmpty from 'lodash/map';
import find from 'lodash/find';
import { isBrowser, isMobile } from "react-device-detect";
import { DropdownSelect } from '@vds/selects';
import Icon from '@vds/icons';
import { spacers } from '@vds/theme';
import { Notification } from '@vds/notifications';
import InternetPlanStatic from '../FourGPlans/InternetPlanStatic';
import ReCAPTCHA from "react-google-recaptcha";
import { add } from "lodash";


const recaptchaRef = React.createRef();

const AddressTipsModal = styled(Modal)`
height: auto;
> div:first-child {overflow:hidden}
@media only screen and (max-width: 600px) {
    position: absolute;
    top: 10px;
    right:10px;
    left:9px;
    width: 95vw;
    height: 97vh;
    > div:first-child {
        padding:2px;
    }
}
`;
const PendingCol = styled(Col)`
  margin-bottom:  ${spacers.large} !important;
`;
const ReadOnlyInput = styled(Input)`
input {
    border-bottom: 0.0625rem solid #000000 !important;
    border-left: 0.0625rem solid #d8dada !important;
    border-right: 0.0625rem solid #d8dada !important;
    border-top: 0.0625rem solid #d8dada !important;
    padding: 0.75rem 1rem;
}
`;

const ModGrid = styled(Grid)`
margin-bottom: ${(props) => props.adSpaceHeight ? (props.adSpaceHeight + 'px') : '240px'} !important;
@media only screen and (max-width: 767px) {
    margin-bottom:  50px !important;
}
`

class BulkAddressValidationPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showZip: true,
            showModal: false,
            streetValue: "",
            isCheckAvailability: false,
            addressError: false,
            isNewService: 'Y',
            streetAdressInfo: {},
            hasPriceQuote: 'N',
            ad: '',
            adSlotHeight: 0,
            adSpaceHeight: '',
            unitError: false,
            initiateChat: false,
            showIEBanner: true,
            multiAddress :['1'],
            textAddress :[{}],
            bulkAddressPayload :[{}],
            bulkUnitData :[{}],
            stateIndex : 0,
            recaptchaValue:''

        };
        this.adRef = React.createRef(null);
        this.mainRef = React.createRef(null);
        window.scrollTo(0, 0);
        props.hideGlobalErrorMessage();
        window.onbeforeunload = function () {
            window.scrollTo(0, 0);
        }
        // const self = this;
        // window.addEventListener('beforeunload', self.props.clearGlobalStore);
        window.localStorage.setItem('customizeProductsCompleted', "");
    }

    componentDidMount() {
        document.title = 'BI Qualification Tool'
        window.scrollTo(0, 0);
        const addressData = this.props.addressData;
        this.props.clearGlobalStore();
        // this.props.presetAddressinfo(addressData);
        // this.props.initiateGlobalSession();
        this.props.setExistingCustomer(false);
        this.props.hasPendingOrder(false);
        this.props.enableCheckAvailblity(true);
        const values = queryString.parse(this.props.location.search);
        const SMBBANNERID = values && values.SMBBANNERID;
        if (SMBBANNERID) {
            this.props.setBannerInfo(SMBBANNERID);
        }
        this.props.hideGlobalErrorMessage();
        this.props.saveCurrentLocation(window.location.pathname);
        window.localStorage.setItem('SOURCE', '');
        this.setState({ initiateChat: true });
        this.getLqPageAds();
    }

    getLqPageAds = () => {
        if (ENABLE_AEM_CHANGES === 'true' || ENABLE_AEM_CHANGES === true) {
            // setTimeout(() => {
            this.props.getLqPageAds()
            // }, 2000);
        }
    }
   
    componentDidUpdate() {
        if (this.adRef?.current && isBrowser && this.mainRef?.current?.clientHeight) {
            const mainContentHeight = this.mainRef.current.clientHeight;
            const adSlotHeight = this.getBiggestHeight(this.adRef.current);
            const defaultBottomMargin = 240;
            let adSpaceHeight = adSlotHeight > mainContentHeight ? (adSlotHeight - mainContentHeight) : defaultBottomMargin;
            adSpaceHeight = adSpaceHeight <= defaultBottomMargin ? defaultBottomMargin : adSpaceHeight;
            if (adSpaceHeight !== this.state.adSpaceHeight) {
                this.setState({ adSlotHeight, adSpaceHeight });
            }
        }
        if (this.state.initiateChat) {
            // SiteAnalytics.trackPageInfo("LQ");
            // this.props.getChatInfo("Addressvalidation");
            window.enableProactiveChat && window.enableProactiveChat();
            
            this.setState({ initiateChat: false });
        }
       
    }

    getBiggestHeight = (element) => {
        let height = element.clientHeight || 0;
        const childElements = element.querySelectorAll("div");
        childElements.forEach((child) => {
            if (child.clientHeight > height) {
                height = child.clientHeight;
            }
        });
        return height;
    };

    selectThisZipcode = (zipCode) => {
        this.setState({ streetValue: "", addressError: false, unitError: false });
        this.props.selectThisZipcode(zipCode);
        if (window?.newrelic?.addPageAction) {
            // window.newrelic.addPageAction('zipcode', {data: zipCode });
        }
    }
 handleStreetAddress = (value,index) =>{
    let addresstext = this.state.textAddress;
    let obj = {
        addressValue :value,       
    }
    // if(addresstext[index]){
    //     addresstext[index].addressValue = value;
    // }
    if( this.state.textAddress.length >0 && this.state.textAddress[index])
    {
        addresstext[index] = obj;
        this.setState({textAddress : addresstext})
    }
    else{
        addresstext.push(obj);
   this.setState({textAddress : addresstext})
    }
    // addresstext[index].addressValue = value;
    // this.setState({textAddress : addresstext})

 }

    saveAddressValue = (selectedStreetAddress,index)=>{

        let obj = {
            addressValue :selectedStreetAddress.disprawstr,
            addressId : selectedStreetAddress.ntasAddrID,
            locusId : selectedStreetAddress.locusID
        }
        let addresstext = this.state.textAddress;
        // this.setState({stateIndex:index});
    if( this.state.textAddress.length >0 && this.state.textAddress[index])
    {
        addresstext[index] = obj;
        this.setState({textAddress : addresstext})
    }
    else{
        addresstext.push(obj);
   this.setState({textAddress : addresstext})
    }
    }

bulkAddressPayload = (address,index) =>{
    this.props.saveIndex(index);
    let obj = {
        addressLine1: address.dispstr,
        addressLine2: '',
        city: address.muni,
        stateProvince: address.state,
        postalCode:address.zip
    }
    let bulkPayload = this.state.bulkAddressPayload;
       
    if(bulkPayload.length > 0  && bulkPayload[index])
    {
        bulkPayload[index] = obj;
        this.setState({bulkAddressPayload : this.state.bulkAddressPayload})
    }
    else{
        bulkPayload.push(obj);
        this.setState({bulkAddressPayload : bulkPayload})
    }

}
    selectThisUnit = (unit,index) => {

        let selectedUnit = unit.unit;
        let bulkPayload = this.state.bulkAddressPayload;
       
    if(bulkPayload.length > 0  && bulkPayload[index])
    {
        if(bulkPayload[index])
        {
        bulkPayload[index].addressLine2 = selectedUnit;
        this.setState({bulkAddressPayload : this.state.bulkAddressPayload})
        }
    }
   
        // let selectedUnit = unit.unit;
        // const streetInfo = this.props.selectedStreetAddress;
        // if (!isBlur || addressFound) {
        //     this.setState({ unitError: false });
        // }
        // if (selectedUnit === "noUnit") {
        //     this.props.selectThisUnit("");
        //     //Updating it for the case where you select no unit aftrer selecting any other uning
        //     streetInfo.ntasAddrID = streetInfo.baseAddressId;
        // } else if (selectedUnit === "I don't live in a unit") {
        //     this.props.selectThisUnit(unit);
        //     streetInfo.ntasAddrID = streetInfo.baseAddressId;
        // } else {
        //     this.props.selectThisUnit(unit);
        //     if (unit.addressId) {
        //         streetInfo.ntasAddrID = unit.addressId;
        //     }
        //     // streetInfo.baseAddressId = unit.baseAddressId ||  "0";
        //     this.setState({
        //         streetAdressInfo: streetInfo
        //     })
        //     this.props.selectThisStreetAddress(streetInfo);
        //     if (window?.newrelic?.addPageAction) {
        //         // window.newrelic.addPageAction('unit', {data: {unit} });
        //     }
        // }
        // this.props.resetDoLoopFlags();
    };

    selectedStreetAddress = (street) => {
        this.setState({ streetAdressInfo: street });
        this.props.selectThisStreetAddress(street);
        if (window?.newrelic?.addPageAction) {
            // window.newrelic.addPageAction('street', {data: street }); 
        }
    };

    handleModal = (showModal) => {
        this.setState({ showModal });
    };

    getStreetValue = (value) => {
        const { streetAdressInfo } = this.state;
        if (!isEmpty(this.state.streetAdressInfo) && this.state.streetAdressInfo.street !== value) {
            streetAdressInfo.ntasAddrID = "";
        }
        this.setState({ streetValue: value, addressError: false, unitError: false });
    };

    validateAddress = () => {
        if (!this.props.selectedStreetAddress && !this.state.streetValue?.trim()) {
            this.setState({ addressError: true })
            return false;
        }
        return true;
    }

    validateUnits = () => {
        const { selectedStreetAddress, unitList, selectedUnit } = this.props;
        const streetInfo = this.props.selectedStreetAddress;
        if (selectedStreetAddress && unitList) {
            if (!selectedUnit) {
                this.setState({ unitError: true });
                if (this.validateAddress()) {
                    const inputContainer = document.getElementById("Unit-inputbox");
                    if (inputContainer) {
                        const inputs = inputContainer.getElementsByTagName("input");
                        if (inputs && inputs[0]) {
                            inputs[0].focus();
                        }
                        this.props.getUnits();
                    }
                }
                return false;
            } else {
                let flag = false;
                if (selectedUnit.unit === "I don't live in a unit") {
                    flag = true;
                } else {
                    map(unitList, unitObj => {
                        if (this.formatString(unitObj.unit) === this.formatString(selectedUnit.unit) || selectedUnit.unit === "I don't live in a unit") {
                            flag = true;
                            if (unitObj.addressId) {
                                streetInfo.ntasAddrID = unitObj.addressId;
                            }
                            this.setState({
                                streetAdressInfo: streetInfo
                            })
                            this.props.selectThisStreetAddress(streetInfo);
                        }
                    });
                }
                if (!flag) {
                    this.setState({ unitError: true });
                    if (this.validateAddress()) {
                        const inputContainer = document.getElementById("Unit-inputbox");
                        if (inputContainer) {
                            const inputs = inputContainer.getElementsByTagName("input");
                            if (inputs && inputs[0]) {
                                inputs[0].focus();
                            }
                            this.props.getUnits();
                        }
                    }
                    return flag;
                }
            }
        }
        return true;
    }

    formatString = str => {
        return str ? str?.replace(/\s/g, '')?.replace(/,/g, '')?.toLowerCase()?.trim() : "";
    }


    // triggerAddressQualification = (historyObjectForNavigation, selectedStreetAddress) => {
    //     if (!this.props.selectedStreetAddress) {
    //         this.props.selectThisStreetAddress({ street: this.props.streetTermEnteredByUser });
    //     }
    //     this.setState({ showModal: false });
    //     const { selectedZipcode } = this.props
    //     this.props.triggerAddressQualification(historyObjectForNavigation, selectedStreetAddress, selectedZipcode);
    //     // if(ENABLE_OMNI_CART === "true") {
    //     // this.props.triggerOptixAddressQualification(historyObjectForNavigation)
    //     // }
    //     this.props.setNewAddressFlow(true)
    // };

    onDropdownListDismiss = (isCheckAvailability) => {
        this.setState({ isCheckAvailability });
    };

    getFormatedAddress = (obj) => {
        if (obj.AddressId) {
            if (this.props.selectedZipcode && this.props.selectedZipcode.zip !== obj.ZipCode) {
                this.props.getZipcodes(obj.ZipCode.toString()?.trim(), true);
            }
            let splitTerm = obj.ElevationType || obj.UnitType;
            if (obj.ElevationType && obj.UnitType) {
                const elevationIndex = obj.ParsedRawString?.trim()?.indexOf(obj.ElevationType);
                const unitIndex = obj.ParsedRawString?.trim()?.indexOf(obj.UnitType);
                splitTerm = elevationIndex < unitIndex ? obj.ElevationType : obj.UnitType;
            }
            const street = splitTerm ? obj.ParsedRawString?.trim().split(splitTerm)[0] : obj.ParsedRawString?.trim();
            const { streetAdressInfo } = this.state;
            streetAdressInfo.ntasAddrID = obj.AddressId.toString().split(".")[0];
            streetAdressInfo.baseAddressId = "0";
            streetAdressInfo.street = street?.trim();
            const unit = obj.ParsedRawString?.trim().split(street?.trim())[1];
            streetAdressInfo.unit = unit?.trim();
            this.setState({
                streetAdressInfo,
                streetValue: obj.ParsedRawString?.trim(),
                addressError: false,
                unitError: false
            });
            this.props.selectThisStreetAddress(streetAdressInfo);

            // if(unit) {
            //     this.selectThisUnit({unit:unit.trim()});
            // } 
            this.props.multipleAddrSelectionsWithId(streetAdressInfo);
            // setTimeout(this.props.multipleAddrSelectionsWithId.bind(this), 2000);
        } else if (obj.UnitType || obj.ElevationType) {
            let splitTerm = obj.ElevationType || obj.UnitType;
            if (obj.ElevationType && obj.UnitType) {
                const elevationIndex = obj.ParsedRawString?.trim()?.indexOf(obj.ElevationType);
                const unitIndex = obj.ParsedRawString?.trim()?.indexOf(obj.UnitType);
                splitTerm = elevationIndex < unitIndex ? obj.ElevationType : obj.UnitType;
            }
            const street = splitTerm ? obj.ParsedRawString?.trim().split(splitTerm)[0] : obj.ParsedRawString?.trim();
            // const street = obj.ParsedRawString.trim().split(obj.ElevationType || obj.UnitType)[0];
            const unit = obj.ParsedRawString?.trim().split(street?.trim())[1];
            const { streetAdressInfo } = this.state;
            streetAdressInfo.ntasAddrID = "";
            streetAdressInfo.baseAddressId = "";
            streetAdressInfo.street = street?.trim();
            this.setState({
                streetAdressInfo,
                streetValue: street?.trim(),
                addressError: false,
                unitError: false
            });
            this.props.selectThisStreetAddress(streetAdressInfo);
            this.props.getMultipleAddrSelections({ street: street?.trim(), unit });
        } else {
            const street = obj.ParsedRawString?.trim();
            const { streetAdressInfo } = this.state;
            streetAdressInfo.ntasAddrID = obj.AddressId;
            streetAdressInfo.baseAddressId = "0";
            streetAdressInfo.street = street;
            this.setState({
                streetAdressInfo,
                streetValue: street,
                addressError: false,
                unitError: false
            });
            this.props.selectThisStreetAddress(streetAdressInfo);
            this.props.getMultipleAddrSelections({ street });
        }
    }
multiTextClick = () =>{
    // e.preventDefault();
   let multiAddress = this.state.multiAddress;
   multiAddress.push("text");
   this.setState({multiAddress :this.state.multiAddress})
}
    multipleAddrRadioClick = (e) => {
        const { value } = e.target
        if (value === "cantfind") {
            this.setState({
                showModal: value === "cantfind",
                showZip: value === "reEnter"
            })
        } else if (value === "reEnter") {
            this.setState({
                showModal: value === "cantfind",
                showZip: value === "reEnter"
            })
            this.props.populateHasMutipleAddress(false);
            this.props.resetZipcodeForm('');
        } else {
            const selectedItem = find(this.props.addressQualificationDetails.AddressList, ['ParsedRawString', value])
            // this.getStreetValue(value);
            if (selectedItem) {
                this.getFormatedAddress(selectedItem);

            } else {
                this.props.selectThisStreetAddress({ street: value });
            }
            // this.props.getStreetAddress(value); 
            this.props.resetDoLoopFlags();
        }
        this.props.postUIEventLog({ eventType: 'log', eventName: "Multiple Address Radio Input", sectionName: "LQ", log: value });
    }

    newService = (e) => {
        this.setState({ isNewService: e.target.value });
    }

    priceQuote = (value) => {
        this.setState({ hasPriceQuote: value })
    }

    showPendingOrderPage = (e, hasQuote) => {
        if (this.state.hasPriceQuote === "Y" || hasQuote) {
            window.sessionStorage.setItem('optixQuoteNum', this.props.priceQuoteNumber);
            // SiteAnalytics.trackOptixQuoteNumber(this.props.priceQuoteNumber);
            // SiteAnalytics.trackLQPageSelectedQuoteOption("Review/access existing quote selected");
            this.props.history.push("/optix-checkout");
        }
        else if (this.state.isNewService === 'Y' && this.props.addressData.hasPendingOrder) {
            // SiteAnalytics.trackLQPageSelectedQuoteOption("Setup a new service selected");
            // SiteAnalytics.trackQualificationResponse(window.LQRequestBody, window.LQResponse);
            // SiteAnalytics.trackProductsList(window.LQResponse);
            this.props.disableCheckAvailblity(false);
        } else if (this.state.isNewService === 'Y' && !this.props.addressData.hasPendingOrder) {
            // if (this.props?.addressQualificationDetails?.AddressIdPresent !== "Y" && !isNightTimeWindow()) {
            if (!isNightTimeWindow()) {
                // SiteAnalytics.trackLQAttempts(window.LQRequestBody, { type: 'lq-address-validation', data: window.LQResponse });
                // SiteAnalytics.trackLQSuccess(window.LQRequestBody, { type: 'customize-order', data: window.LQResponse });
                // SiteAnalytics.trackLQPageSelectedQuoteOption("Setup a new service selected");
                // SiteAnalytics.trackQualificationResponse(window.LQRequestBody, window.LQResponse);
                // SiteAnalytics.trackProductsList(window.LQResponse);
                if (window?.newrelic?.addPageAction) {
                    window.newrelic.addPageAction('LQAttempts', { data: window.LQRequestBody });
                    window.newrelic.addPageAction('LQSuccess', { data: window.LQRequestBody });
                }
            }
            this.props.history.push({ pathname: "/customize-order", state: { prevPage: 'LQ' } });
        } else {
            // Redirect to login - Need to change
            // SiteAnalytics.trackLQPageSelectedQuoteOption("Add or change existing service selected");
            // SiteAnalytics.trackQualificationResponse(window.LQRequestBody, window.LQResponse);
            // SiteAnalytics.trackProductsList(window.LQResponse);
            window.location.href = EXISTING_USER_URL;
        }
    }

    continuePendingOrder = (value) => {
        // SiteAnalytics.trackOrderStatus(value);
        if (window?.newrelic?.addPageAction) {
            window.newrelic.addPageAction(`Pending Order ${value ? 'Yes' : 'No'} Button Click`, { data: window.LQRequestBody });
        }
        if (!value) {
            // if (this.props?.addressQualificationDetails?.AddressIdPresent !== "Y" && !isNightTimeWindow()) {
            if (!isNightTimeWindow()) {

                // SiteAnalytics.trackLQAttempts(window.LQRequestBody, { type: 'lq-address-validation', data: window.LQResponse });
                // SiteAnalytics.trackLQSuccess(window.LQRequestBody, { type: 'customize-order', data: window.LQResponse });
                if (window?.newrelic?.addPageAction) {
                    window.newrelic.addPageAction('LQAttempts', { data: window.LQRequestBody });
                    window.newrelic.addPageAction('LQSuccess', { data: window.LQRequestBody });
                }
            }
        }
        value ? this.props.history.push("/pending-order") : this.props.history.push({ pathname: "/customize-order", state: { prevPage: 'LQ' } });
        this.props.postUIEventLog({ eventType: 'log', eventName: "Continue Pending Order Button Click", sectionName: "LQ", log: "" });
    }

    handleBackClickEvent = () => {
        this.props.enableCheckAvailabilityButton(true);
        this.props.enableCheckAvailblity(true);
        this.props.postUIEventLog({ eventType: 'log', eventName: "Pending Order Back Button Click", sectionName: "LQ", log: "" });
    }

    handleGoBack = () => {
        this.props.history.go(-1);
    }
    handleValidationCheck = ()=>{
    
      var addressText = this.state.multiAddress
      let bulkpayload = this.state.bulkAddressPayload;
      if(this.state.bulkAddressPayload && Object.keys(this.state.bulkAddressPayload[0]).length === 0)
      {
          return true;
      }
      if(addressText.length > this.state.bulkAddressPayload.length)
      {
        return true;
      }
      if(this.props.bulkAddressReducerData!==undefined){
          let resultVal = false
      this.state.textAddress.length&&this.state.textAddress.map(value=>{
        this.props.bulkAddressReducerData!==undefined&& this.props.bulkAddressReducerData.length&&this.props.bulkAddressReducerData.map(data=>{
            if(Object.keys(value).length && value.locusId===data.locusid){
                const arrayVal = value.addressValue.split(',')
                this.state.bulkAddressPayload.length&&this.state.bulkAddressPayload.map(bulk_add=>{
                    if(Object.keys(bulk_add).length&&arrayVal[0]=== bulk_add.addressLine1&&!bulk_add.addressLine2){
                        resultVal=true
                    }
                })
            }
        })
      })
      return resultVal
    }
    //   if(this.props.bulkAddressReducerData !==undefined&&)
    //   {
    //      let checkAddressText = this.state.bulkAddressPayload.find(x=>x.addressLine1 == "" || x.addressLine1 == undefined);

    //      let ss = checkAddressText;
    //   }
      return false;
      
    }

    setCityState = (e, value) => {
        let userInput = e?.target?.value;
        if (userInput) {
            // userInput = userInput.trim();
            let data = {
                zip: this.props.selectedZipcode.zip,
                altCity: "",
                state: ""
            }
            if (value == "City") {
                data = {
                    zip: this.props.selectedZipcode.zip,
                    altCity: userInput,
                    state: this.props.selectedZipcode.state
                }
            } else {
                data = {
                    zip: this.props.selectedZipcode.zip,
                    altCity: this.props.selectedZipcode.altCity,
                    state: userInput
                }
            }
            this.props.setCityAndState(data);

        }
    }

    submitPayload = ()=>{
      const history =  this.props.history;
        let bulkpayload = this.state.bulkAddressPayload;
        if(bulkpayload.length > 0){
            let payloadObj ={
                "QueryType": "bulk-address",
               "GUID": "cea7b3c1-0fdc-4788-8141-a01eeb192938",
              "ClientID": "BBA",
              "inputAddress": bulkpayload
            }
            this.props.submitBulkPayloadAddress(payloadObj,history);
        }
    }
    componentWillUnmount(){
        document.title = 'Order Verizon® Fios Small Business Internet'
     }
    render() {

        console.log("render");
        console.log(this.props.bulkAddressReducerData);
        const { showZip, showModal, showIEBanner } = this.state;
        const {
            streetAddressSuggestionList,
            addressQualificationDetails,
            optixAddressQualificationDetails,
            selectedZipcode,
            selectedStreetAddress,
            enableCheckAvailability,
            unitList,
            hasMultipleAddress,
            selectedUnit,
            unitsTriggered,
            unitsResponded
        } = this.props;

        let cityAndState = (selectedZipcode && selectedZipcode.city && selectedZipcode.state) ? selectedZipcode.city + ' , ' + selectedZipcode.state : '';
        let disableButton = !selectedStreetAddress ? true :
            selectedStreetAddress && (!unitsTriggered || !unitsResponded) && !selectedUnit ? true :
     
            selectedStreetAddress && unitsResponded && unitsTriggered && unitList && !selectedUnit ? true : false;
                let addressText  = ''
            
                addressText =    this.state.multiAddress.map((e,index)=>{
                    let unitValue = "";
                    let textAddress  = this.state.textAddress[index];
             let unitTextValue  = {};
            if(this.state.bulkAddressPayload && this.state.bulkAddressPayload.length > 0 && this.state.bulkAddressPayload[index])
            {
                unitTextValue.unit  = this.state.bulkAddressPayload[index]?.addressLine2 == undefined ?"" : this.state.bulkAddressPayload[index]?.addressLine2;
            }
                    if(textAddress && Object.keys(textAddress).length > 0 && this.props.bulkAddressReducerData && this.props.bulkAddressReducerData.length > 0)
                    {
                        // if(textAddress.addressId != undefined && textAddress.locusId != undefined){
                            if(Object.keys(textAddress).length >1){
                        unitValue  = this.props.bulkAddressReducerData.find(x=> x. locusid == textAddress.locusId )
                            }
                        // }
                    }
                   return(
                        <div className="loop-qualification-content">
                                
                <StreetAddress
                    selectedZipcode={selectedZipcode}
                    addressIndex = {index}
                    value = {textAddress?.addressValue}
                    address={selectedStreetAddress}
                    getStreetAddress={this.props.getStreetAddress}
                    handleStreetAddress = {this.handleStreetAddress}
                    streetAddressSuggestionList={streetAddressSuggestionList}
                    streetTermEnteredByUser={this.props.streetTermEnteredByUser}
                    selectThisStreetAddress={this.selectedStreetAddress}
                    bulkAddressPayload ={this.bulkAddressPayload}
                    saveAddressValue ={this.saveAddressValue}
                    getUnits={this.props.getUnitsforBulkAddress}
                    getStreetValue={this.getStreetValue}
                    onDropdownListDismiss={this.onDropdownListDismiss}
                    inputRef={(r) => { this.r = r }}
                    handleModal={this.handleModal}
                    addressError={this.state.addressError}                 
                    history={this.props.history}
                    resetDoLoopFlags={this.props.resetDoLoopFlags}
                    lqStreetAddrError={this.props.addressData.lqStreetAddrError}
                    postUIEventLog={this.props.postUIEventLog}
                    setDontShowUnit={this.props.setDontShowUnit}
                    setAddressFieldError={() => {
                        this.setState({
                            addressError: true
                        })
                    }}
                />
            
           

              {unitValue && unitValue.unitData &&
                    <Unit
                        unitList={unitValue.unitData}
                        addressIndex = {index}
                        selectThisUnit={this.selectThisUnit}
                        unitTextValue ={unitTextValue}
                        // showCheckAvailability={this.props.showCheckAvailability}
                        selectedUnit={unitTextValue}
                        totalUnits={this.props.totalUnits}
                        getUnitsByUnitterm={this.props.getUnitsByUnitterm}
                        inputRef={(r) => { this.r = r }}                    
                        resetDoLoopFlags={this.props.resetDoLoopFlags}
                        unitError={this.state.unitError}
                        validateUnits={this.validateUnits}
                        streetAdressInfo={this.state.streetAdressInfo}
                        emptyUnitsError={this.props.addressData.emptyUnitsError}
                        baseAddrUnitError={this.props.addressData.baseAddrUnitError}
                        postUIEventLog={this.props.postUIEventLog}
                        iDontLiveUnit={this.props.addressData.iDontLiveUnit}
                    />
              } 
            
            </div>);
             }) ; 
  
        return (
          
            <div ref={this.mainRef}>
                  <Loader active={this.props.toggleLoadingBulkAddress} />
                <div id="dvAutopay" className="hideSection"></div>


                {isIEBrowser() && showIEBanner &&
                 <Notification type="warning" className ="ie-banner">
                    <div style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap' }}><p style={{ marginRight: '20px', lineHeight: '1.2rem', fontWeight: 'bold' }}> Your web browser is out of date.<br />
                    <p style={{fontWeight: 'normal', marginTop:0, marginBottom:2}}>For the best browser experience, please use latest version of Chrome, Safari, Firefox or Microsoft Edge. </p>
              </p><Button onClick={() => { this.setState({ showIEBanner: false }) }} secondary size="small" >Ignore</Button>
                </div>
                    </Notification>}
             
                    <Grid className="address-validation" colGutter={false} adSpaceHeight={this.state.adSpaceHeight} >
                        <Row>
                            
                            <Col colSizes={{ "mobile": 4, "tablet": 9, "desktop": 9 }}>
                                {/* {this.props.toggleLoadingSpinner && this.props?.addressData?.chkAvailibtyClicked ? <SpinnerComponent /> : ""} */}
                                <div className="Banner Banner-Title">
                                    <Title size="extraExtraLarge" primitive="h1">
                                        Where would you like internet<br /> service for your business?
                                    </Title>
                                    {/* <div className="Banner-Content">
                                        <Subtitle primitive="h4">Get exclusive online offers for Fios eligible addresses. </Subtitle>
                                    </div> */}
                                </div>
                                {/* {isMobile && <div className='moreStep'>
                                    <Title size="medium" primitive="h1">
                                        Just one more step </Title>
                                    <p >By providing this information we can provide the most relevant pricing and bundle offers available for your business.</p>
                                </div>} */}
                            </Col>                           
                           
                        </Row>
                        <Row>
                            <Col colSizes={{ "mobile": 4, "tablet": 6, "desktop": 6 }}>
                                {addressText}
                               
                               <div className="recap-add-bulk">
                                <div className="recaptcha">
                                <ReCAPTCHA
                    ref={recaptchaRef}
                    // size="invisible"
                    sitekey={GOOGLE_RECAPTCHA_SITEKEY}
                    onChange={(e) => { 
                        console.log(e);
                        const recaptchaValue = recaptchaRef.current.getValue();
                        this.setState({recaptchaValue})
                        console.log(recaptchaValue);
                    }}
                    onExpired={() =>{  this.setState({recaptchaValue: ''})}}
                />
                                </div>  
                                <div className='moreStep' style={{ marginLeft: 22, padding: "4px 2px 0px 9px" }}>
                                    {this.state.multiAddress.length>24 ? null : 
                                    <span style= {{fontWeight:'bold',cursor:'pointer'}} onClick={this.multiTextClick} size="large" primitive="h2" >
                                    + Add Address </span>}
                                     <br/><br/>
                                  
                                        <TextLink type="standAlone" onClick={()=>this.props.history.push('/bulk-address-upload')}>Bulk Address Upload</TextLink>
                                </div>
                                </div>                            
                               <div className="Check-Availability">
                    <div className="Check-Availability-Button">
                        <Button onClick ={()=>{this.submitPayload()}} disabled={this.handleValidationCheck() || !this.state.recaptchaValue} >
                            Continue
                        </Button>
                    </div>
                </div>
                                
                            </Col>
                            <Col colSizes={{ "mobile": 4, "tablet": 6, "desktop": 6 }}>
                            <div className="ver-wl-map">
                                <TextLink onClick = {()=>{window.open('https://www.verizon.com/coverage-map/','_blank')}}>Verizon Wireless Coverage Map</TextLink>
                                <Body size='medium'>Explore Verizon 5G and 4G LTE network coverage in your area.</Body>
                            </div></Col>
                            {/* <Col colSizes={{ "mobile": 4, "tablet": 3, "desktop": 3 }}>
                                {!isMobile && <div className='moreStep' style={{ marginLeft: 22, marginTop: 43, padding: "4px 2px 0px 9px" }}>
                                    <Title size="medium" primitive="h1">
                                        Just one more step </Title>
                                    <p >By providing this information we can provide the most relevant pricing and bundle offers available for your business.</p>
                                </div>
                                }

                            </Col> */}
                        </Row>
{/* <Row>
    
</Row> */}

                    
                        <Row>
                            <Col colSizes={{ "mobile": 4, "tablet": 6, "desktop": 6 }}>
                                {this.props.showBulkAddressPlan ? (
                                    <InternetPlanStatic
                                        showBulkAddressPlan={this.props.showBulkAddressPlan}
                                        saveBulkAddress={this.props.saveBulkAddress}
                                        history= {this.props.history}
                                    />
                                ) : ''}
                            </Col>
                        </Row>
                        {/* {this.props.lqPageAds && isMobile ?
                            <Row>
                                <Col colSizes={{ "mobile": 4, "tablet": 12, "desktop": 12 }}>
                                <InnerHTML html={this.props.lqPageAds}/>
                                </Col>
                            </Row> : <></>
                        } */}
                    </Grid >
               
                   
                
            </div >
        );
    }
}

const mapStateToProps = (state) => {
    return {
        addressData: state.AddressValidationPage,
        saveBulkAddress: state.BulkAddressValidationPage.saveBulkAddress,
        showBulkAddressPlan: state.BulkAddressValidationPage.showBulkAddressPlan,
        toggleLoadingBulkAddress :state.BulkAddressValidationPage.toggleLoadingBulkAddress
    };
};

const mapDispatchToProps = (dispatch) => ({
    populateHasMutipleAddress: (data) => { dispatch(setHasMutipleAddress(data)); },
    enableCheckAvailblity: (data) => { dispatch(enableCheckAvailblity(data)); },
    disableCheckAvailblity: (data) => { dispatch(disableCheckAvailblity(data)); },
    enableCheckAvailabilityButton: (data) => { dispatch(enableCheckAvailblityButton(data)); },
    resetZipcodeForm: (data) => { dispatch(resetZipcodeForm(data)); },
    setBannerInfo: (data) => { dispatch(setBannerInfo(data)); },
    setNewAddressFlow: (data) => { dispatch(setNewAddressFlow(data)); },
    setExistingCustomer: (data) => { dispatch(setExistingCustomer(data)); },
    hasPendingOrder: (data) => { dispatch(hasPendingOrder(data)); },
    presetAddressinfo: (data) => { dispatch(setAddressInfo(data)) },
    redirectLBOPage: (data) => { dispatch(redirectLBOPage(data)) },
    hideGlobalErrorMessage: () => { dispatch(toggleGlobalErrorMessage({ enableNotification: false })) },

    //for chat integration
    getChatInfo: (data) => dispatch(getChatInfo(data)),
    showSpinner: (data) => { dispatch(showSpinner(data)); },
    resetDoLoopFlags: () => { dispatch(resetDoLoopFlags()) },
    checkAvailAPICall: () => { dispatch(checkAvailAPI()) },
    setEmptyUnitsError: (data) => { dispatch(setEmptyUnitsError(data)) },
    saveCurrentLocation: (data) => { dispatch(saveCurrentLocation(data)) },
    multipleAddrSelectionsWithId: (data) => { dispatch(multipleAddrSelectionsWithId(data)) },
    postUIEventLog: (data) => { dispatch(postUIEventLog(data)) },
    setDontShowUnit: (data) => { dispatch(setDontShowUnit(data)) },
    setCityAndState: (data) => { dispatch(setCityAndState(data)) },
    getLqPageAds: (data) => dispatch(getLqPageAds(data)),
    fetchUnitBulkStatus: (data) => dispatch(fetchUnitBulkStatus(data)),
    saveIndex: (data) => dispatch(saveIndex(data)),
    submitBulkPayloadAddress: (data,history) => dispatch(submitBulkPayloadAddress(data,history)),
    
    
});

BulkAddressValidationPage = connect(mapStateToProps, mapDispatchToProps)(BulkAddressValidationPage);
export default BulkAddressValidationPage;
